import en from './en.js';
import nl from './nl.js';
//import _ from 'lodash'
//import logger from '@fentures/logger';

let availableTranslations = { en, nl }

export default class I18n {

  constructor(language = "nl") {

    if (!availableTranslations[language])
      language = "nl";

    this._translations = availableTranslations[language];
    this._language = language;
    this._availableLanguages = availableTranslations;

  }

  translate(text, ...args) {
    text ??= ''
    return (availableTranslations[this._language][text.replace(/[^A-Za-z0-9_]/g, "_")] || text)
      .split("%s")
      .map((part, i)=> `${part}${args[i] || ''}`)
      .join('');
  }

  setLanguage(language) {
    this._language = language;
  }

  getLanguage() {
    return this._language;
  }
}
